<tickets-badge-button [count]="messages().length" (open)="openTicketsDialog()" />
